<template>
  <span class="inspection-rejection">
    <v-btn
      outlined
      color="primary"
      :disabled="disabled || loading || !canReject"
      @click="openDialog"
    >
      Prüfung ablehnen
    </v-btn>
    <NewModalDialog
      v-if="dialogVisible"
      :enable-note="false"
      @cancel-data="closeDialog"
      @save-data="rejectInspection"
    >
      <template #body>
        <div class="px-4">
          <h3 class="mb-4">Prüfung ablehnen</h3>
          <v-textarea
            v-model="reason"
            label="Ablehnungsgrund *"
            outlined
            :disabled="loading"
            :error-messages="
              reasonMissing ? ['Bitte Ablehnungsgrund eingeben.'] : []
            "
            @input="reasonMissing = false"
          />
          <v-alert v-if="requestFailed" type="error" text>
            Ablehnen fehlgeschlagen. Bitte erneut versuchen.
          </v-alert>
        </div>
      </template>
      <template #footer>
        <div class="rejection-actions">
          <v-btn
            color="primary"
            :loading="loading"
            :disabled="loading || disabled || !canReject"
            @click="rejectInspection"
          >
            Prüfung ablehnen
          </v-btn>
          <v-btn text :disabled="loading" @click="closeDialog">
            Abbrechen
          </v-btn>
        </div>
      </template>
    </NewModalDialog>
  </span>
</template>

<script>
import { NewModalDialog } from '@newnetzportal/netzportal-webapp-storybook-components';
import noteService from '@/services/NoteService';
import { updateCommissioningOrderStatus } from '@/services/CommissioningService';

export default {
  name: 'CommissioningInspectionRejection',
  components: { NewModalDialog },
  props: {
    order: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      dialogVisible: false,
      reason: '',
      reasonMissing: false,
      requestFailed: false,
      loading: false,
      savedReason: null,
    };
  },
  computed: {
    canReject() {
      return this.order.status === 'ORDER_TECHNICAL_FEASIBILITY';
    },
  },
  beforeDestroy() {
    this.$emit('active-change', false);
  },
  methods: {
    openDialog() {
      if (this.disabled || this.loading || !this.canReject) return;
      this.dialogVisible = true;
      this.reasonMissing = false;
      this.requestFailed = false;
      this.$emit('active-change', true);
    },
    closeDialog() {
      if (this.loading) return;
      this.dialogVisible = false;
      this.reason = '';
      this.reasonMissing = false;
      this.requestFailed = false;
      this.$emit('active-change', false);
    },
    async rejectInspection() {
      if (
        !this.dialogVisible ||
        this.loading ||
        this.disabled ||
        !this.canReject
      )
        return;

      const reason = this.reason.trim();
      this.reasonMissing = !reason;
      if (!reason) return;

      this.loading = true;
      this.requestFailed = false;
      const userId = this.$store.getters.getUserId;
      try {
        // A status retry must not add the same reason to history again.
        if (this.savedReason !== reason) {
          const noteResponse = await noteService.addCommissioningNote(
            {
              id: this.order.id,
              user_id: this.order.user_id,
              title: 'Ablehnungsgrund',
              note: reason,
            },
            userId
          );
          if (!noteResponse || noteResponse.error) {
            this.requestFailed = true;
            return;
          }
          this.savedReason = reason;
        }

        if (!this.canReject) return;
        const response = await updateCommissioningOrderStatus(
          {
            id: this.order.id,
            old_value: { status: this.order.status },
            new_value: { status: 'ORDER_DECLINED' },
            remark: reason,
          },
          userId
        );
        if (!response || response.error) {
          this.requestFailed = true;
          return;
        }
        this.$emit('update-order', { status: 'ORDER_DECLINED' });
        this.loading = false;
        this.closeDialog();
      } catch {
        this.requestFailed = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.inspection-rejection {
  display: inline-block;
  margin-left: 12px;
}

.rejection-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
</style>
